const state = () => ({
  userStatus: {
    cvFiles: null,
    isRegisteredSmartAlerts: false,
  },
  currentStep: 1,
  stepperStatus: {},

  errors: [],
  initializedCVW: false,
});

export default state;
